export const onLoad = () => {
	document.onreadystatechange = function () {
		// if (document.readyState === "interactive") {
		// 	document.body.classList.add("loaded");
		// }
		if (document.readyState === "complete") {
			document.body.classList.add("loaded");
		}
	};
};
